document.addEventListener('DOMContentLoaded', () => {

    function RowHightChange () {
        $('.product-column-1 .row-item').each(function() {
            var row_num = $(this).attr('row-num')
    
            let maxHeight = 0;
    
            $(`.compare-column .row-item-${row_num}`).each(function() {
                const currentHeight = $(this).height();
                if (currentHeight > maxHeight) {
                    maxHeight = currentHeight;
                }
            })
    
            $(`.row-item-${row_num}`).each(function () {
                $(this).height(maxHeight);
            });
        })
    }

    RowHightChange()

    $('#product-detail-tabs .nav-tab-item').click(function() {
        if($('#product-detail-tabs .nav-tab-item:first').hasClass('active')) {
            $('.product-compare').css('display', 'none')
        } else {
            $('.product-compare').css('display', 'block')
        }
    })

});